<div class="modal-header">
  <h3 class="modal-title">Forgot password</h3>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()" [disabled]="submitted"></button>
</div>

<div class="modal-body">
  <p>Enter the email address for your account and we'll send you a temporary password:</p>
  <form id="form" (ngSubmit)="submit()" ngNativeValidate>
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-envelope"></i>
      </span>
      <div class="form-floating">
        <input id="email" type="email" name="email" [(ngModel)]="email" class="form-control" placeholder="Email" required>
        <label for="email">Email</label>
      </div>
    </div>
  </form>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="submitted">Cancel</button>
  <button type="submit" class="btn btn-primary" form="form" [disabled]="submitted">Submit</button>
</div>
